import { useState, useEffect } from 'react';
import { getModelEstSeconds } from '@/ai/tokenCosts.ts';
import type { CatalogModel } from '@/types/ai.ts';

/**
 * Countdown timer that starts from a model's estimated seconds when `isActive`
 * transitions to true, counting down by 1 each second.
 * Returns the current countdown value (0 when inactive or finished).
 * Optional `context` separates timing observations (e.g. 'single' vs 'batch').
 */
export function useCountdown(isActive: boolean, modelId: string, catalog: CatalogModel[], context?: string): number {
  const [countdown, setCountdown] = useState(0);
  useEffect(() => {
    if (!isActive) { setCountdown(0); return; }
    const total = getModelEstSeconds(modelId, catalog, context);
    setCountdown(total);
    const iv = setInterval(() => {
      setCountdown(prev => (prev <= 1 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(iv);
  }, [isActive, modelId, catalog, context]);
  return countdown;
}
